import Api from "~/core/helper/apiHelper";
const { default: urlcat } = require("urlcat");

const SCHEDULE = "schedule";

export function getSchedule() {
  return Api.asyncGet(urlcat(SCHEDULE));
}

